module.exports = __webpack_public_path__ + "img/webSecurity.0706a038.svg";